import { render, staticRenderFns } from "./SvgPanZoomThumbnail.vue?vue&type=template&id=4cd02652&"
import script from "./SvgPanZoomThumbnail.vue?vue&type=script&lang=js&"
export * from "./SvgPanZoomThumbnail.vue?vue&type=script&lang=js&"
import style0 from "./SvgPanZoomThumbnail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/poi/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/yanick/work/javascript/vue-svg-pan-zoom/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cd02652')) {
      api.createRecord('4cd02652', component.options)
    } else {
      api.reload('4cd02652', component.options)
    }
    module.hot.accept("./SvgPanZoomThumbnail.vue?vue&type=template&id=4cd02652&", function () {
      api.rerender('4cd02652', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/SvgPanZoomThumbnail.vue"
export default component.exports